import React from 'react';
import { Route, Redirect } from 'react-router-dom';

const PrivateRoute = ({
  component: Component,
  authed,
  registered,
  path,
  ...rest
}) => (
  <Route
    {...rest}
    render={
      (props) => (
        authed && registered
          ? <Component {...props} />
          : (
            <Route
              path={path}
              component={() => {
                if (authed && !registered) {
                  console.log('here');
                  window.location.href = `${process.env.PHP_APP_URL || 'http://localhost'}/register`;
                } else {
                  if (process.env.ENVIRONMENT === 'LOCAL') {
                    // Preserve all query parameters for local environment too
                    const currentQueryString = window.location.search;
                    const existingParams = new URLSearchParams(currentQueryString);

                    // Build new params with rel and version first
                    const newParams = new URLSearchParams();
                    newParams.set('rel', path.replace('/', ''));
                    newParams.set('version', '2');

                    // Add all other existing params
                    existingParams.forEach((value, key) => {
                      if (key !== 'rel' && key !== 'version') {
                        newParams.set(key, value);
                      }
                    });

                    window.location.href = `${process.env.WEBAPP_URL || 'http://localhost:8080'}/login?${newParams.toString()}`;
                  }
                  if (process.env.ENVIRONMENT !== 'LOCAL') {
                    let domain;
                    if (process.env.WEBAPP_URL) {
                      domain = process.env.WEBAPP_URL;
                    } else {
                      const isDevelop = process.env.ENVIRONMENT === 'DEVELOP' ? 'dev.app-v3' : 'app.';
                      domain = `https://${process.env.ENVIRONMENT === 'STAGING' ? 'staging.app-v3.' : isDevelop}teambuildr.com`;
                    }
                    // Preserve all query parameters
                    const currentQueryString = window.location.search;
                    const existingParams = new URLSearchParams(currentQueryString);

                    // Build new params with rel and version first
                    const newParams = new URLSearchParams();
                    newParams.set('rel', path.replace('/', ''));
                    newParams.set('version', '2');

                    // Add all other existing params
                    existingParams.forEach((value, key) => {
                      if (key !== 'rel' && key !== 'version') {
                        newParams.set(key, value);
                      }
                    });

                    window.location.href = `${domain}/login?${newParams.toString()}`;
                  }
                  // window.location.href = `http://localhost:8080/login`;
                  // window.location.href = `https://${process.env.ENVIRONMENT === 'STAGING' ? 'staging.' : ''}app-v3.teambuildr.com/login`;
                }

                return null;
              }}
            />
            // <Redirect to={`/login?rel=${path.replace('/', '')}&version=2`} />
          )
      )
    }
  />
);

export default PrivateRoute;
